import { useTranslation } from 'react-i18next';

const ComplianceAuditSection = () => {
  const { t } = useTranslation('pharmacies');

  return (
    <section className="py-20 bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold mb-6">
              Preparación Completa para Auditorías
            </h2>
            <p className="text-xl text-blue-100 mb-8 leading-relaxed">
              Manténgase siempre listo para inspecciones de la DEA, auditorías de seguros y revisiones regulatorias con nuestra documentación organizada y procesos de cumplimiento.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-blue-100">Documentación DEA Schedule II-V organizada</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-blue-100">Pistas de auditoría completas para todas las transacciones</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-blue-100">Informes de cumplimiento automatizados</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-white"></i>
                </div>
                <span className="text-blue-100">Reconciliación de inventario en tiempo real</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/e3b073af594f26a141b83cfe60211073.jpg"
              alt="Preparación de Auditoría de Farmacia"
              className="rounded-xl shadow-2xl object-cover w-full h-80"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900/20 to-transparent rounded-xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComplianceAuditSection;